export const toanLessons = [
  {
    id: 'toan-1',
    title: 'Phương trình bậc hai một ẩn',
    slug: 'phuong-trinh-bac-hai',
    grade: 9,
    subject: 'Toán học',
    views: 28500,
    readTime: 25,
    excerpt: 'Lý thuyết và bài tập về phương trình bậc hai với công thức nghiệm, delta, hệ thức Vi-ét.',
    category: 'Đại số'
  },
  {
    id: 'toan-2',
    title: 'Hàm số bậc nhất và đồ thị',
    slug: 'ham-so-bac-nhat',
    grade: 9,
    subject: 'Toán học',
    views: 24300,
    readTime: 20,
    excerpt: 'Tìm hiểu hàm số bậc nhất y = ax + b, cách vẽ đồ thị và các bài toán liên quan.',
    category: 'Đại số'
  },
  {
    id: 'toan-3',
    title: 'Định lý Pythagore và ứng dụng',
    slug: 'dinh-ly-pythagore',
    grade: 8,
    subject: 'Toán học',
    views: 31200,
    readTime: 18,
    excerpt: 'Định lý Pythagore trong tam giác vuông: a² + b² = c² với bài tập ứng dụng thực tế.',
    category: 'Hình học'
  },
  {
    id: 'toan-4',
    title: 'Phân tích đa thức thành nhân tử',
    slug: 'phan-tich-da-thuc',
    grade: 8,
    subject: 'Toán học',
    views: 26700,
    readTime: 22,
    excerpt: '7 phương pháp phân tích đa thức: đặt nhân tử chung, hằng đẳng thức, nhóm hạng tử...',
    category: 'Đại số'
  },
  {
    id: 'toan-5',
    title: 'Hệ hai phương trình bậc nhất hai ẩn',
    slug: 'he-phuong-trinh-bac-nhat',
    grade: 9,
    subject: 'Toán học',
    views: 22900,
    readTime: 24,
    excerpt: 'Giải hệ phương trình bằng phương pháp thế, cộng đại số và đồ thị.',
    category: 'Đại số'
  },
  {
    id: 'toan-6',
    title: 'Tính chất đường trung tuyến trong tam giác',
    slug: 'duong-trung-tuyen',
    grade: 7,
    subject: 'Toán học',
    views: 19500,
    readTime: 16,
    excerpt: 'Tính chất đường trung tuyến, trọng tâm tam giác và bài tập vận dụng.',
    category: 'Hình học'
  }
];
